import * as React from "react"
const SvgNone = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.714a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138q-1.35-1.35-2.137-3.175a9.7 9.7 0 0 1-.788-3.9 9.7 9.7 0 0 1 .788-3.9A10.1 10.1 0 0 1 4.925 5.64Q6.275 4.29 8.1 3.503a9.7 9.7 0 0 1 3.9-.788 9.7 9.7 0 0 1 3.9.788 10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175a9.7 9.7 0 0 1 .788 3.9 9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.138a9.7 9.7 0 0 1-3.9.787Zm0-2q1.35 0 2.6-.437a8 8 0 0 0 2.3-1.263L5.7 7.814a8 8 0 0 0-1.263 2.3 7.8 7.8 0 0 0-.437 2.6q0 3.35 2.325 5.675T12 20.714m6.3-3.1q.825-1.05 1.262-2.3t.438-2.6q0-3.35-2.325-5.675T12 4.714q-1.35 0-2.6.438a8 8 0 0 0-2.3 1.262z" />
  </svg>
)
export default SvgNone
